export default "__VITE_ASSET__i3K7J2F0__"